import { useTranslation } from 'react-i18next';

import {
  useExtensionRequestStatuses,
  useFilterAuthorities,
  useFilterCategories,
  useFilterConsultationTypes,
  useFilterStatusesAll,
  useReasonsForLateResponse,
  useResponseTypes,
} from 'api';
import { ReportFilter } from 'types';
import { createFilterItem } from '../utils';

type useReportFiltersProps = {
  authorityIds: ReportFilter;
  consultationCategoryIds: ReportFilter;
  consultationStatusIds: ReportFilter;
  consultationTypeIds: ReportFilter;
  extensionRequestStatusIds: ReportFilter;
  lateResponseReasonIds: ReportFilter;
  responseTypeIds: ReportFilter;
};

export const useReportFilters = (): useReportFiltersProps => {
  const { t } = useTranslation('reports');
  const { data: authoritiesData } = useFilterAuthorities();
  const { data: categoriesData } = useFilterCategories();
  const { data: consultationStatusesData } = useFilterStatusesAll();
  const { data: consultationTypesData } = useFilterConsultationTypes();
  const { data: extensionRequestStatusesData } = useExtensionRequestStatuses();
  const { data: reasonsForLateResponseData } = useReasonsForLateResponse();
  const { data: responseTypesData } = useResponseTypes();

  const authorityIds = createFilterItem(
    'AuthorityIds',
    t('authority', 'Authority'),
    authoritiesData?.authorities
  );
  const consultationCategoryIds = createFilterItem(
    'ConsultationCategoryIds',
    t('category', 'Category'),
    categoriesData?.categories
  );
  const consultationStatusIds = createFilterItem(
    'ConsultationStatusIds',
    t('consultation_status', 'Consultation status'),
    consultationStatusesData?.statuses
  );
  const consultationTypeIds = createFilterItem(
    'ConsultationTypeIds',
    t('consultation_type', 'Consultation type'),
    consultationTypesData?.consultationTypes
  );
  const extensionRequestStatusIds = createFilterItem(
    'ExtensionRequestStatusIds',
    t('extension_request_status', 'Extension request status'),
    extensionRequestStatusesData?.statuses
  );
  const lateResponseReasonIds = createFilterItem(
    'LateResponseReasonIds',
    t('late_response_reason', 'Late response reason'),
    reasonsForLateResponseData?.reasonsForLateResponse
  );
  const responseTypeIds = createFilterItem(
    'ResponseTypeIds',
    t('response_type', 'Response type'),
    responseTypesData?.responseTypes
  );

  return {
    authorityIds,
    consultationCategoryIds,
    consultationStatusIds,
    consultationTypeIds,
    extensionRequestStatusIds,
    lateResponseReasonIds,
    responseTypeIds,
  };
};
